import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('MEDIAS_TAG').plugin(axiosPlugin, {template: "array"});

let fetchMediasTagAction = redux.fetchActionGet();


export const fetchMediasTag = (query = {}) => {
    let sort = ['-createdAt', '-count.like', '-count.like', '-count.like'];
    query = {...query, sort: sort[query.period] || sort[query.sort] || sort[0]};
    return fetchMediasTagAction(`/medias?${queryString.stringify(query)}`)
};
export const TYPES = redux.types;

export const resetMediasTag = () => redux.actions.reset();

export const mediasTag = redux.reducer();